import type { CityConfig } from "../city-template/types";

export const nampaConfig: CityConfig = {
  city: "Nampa",
  state: "Idaho",
  stateAbbr: "ID",
  slug: "nampa",
  route: "/cities/nampa",
  title: "Nampa ID Passport — Expedited & Emergency Service | Fast Passport Center",
  metaDescription: "Expedited and emergency passport services in Nampa, Idaho — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Nampa, Caldwell, Boise metro, and all of Canyon County.",
  h1: "Expedited Passport Services in Nampa, ID",
  heroSubtitle: "College of Western Idaho study abroad program starting soon? Canyon County family trip to Mexico booked for spring break? Boise business meeting requiring international travel? Nampa residents — from CWI students to Ford Idaho Center event travelers to Ridgecrest families — trust us for fast, reliable passport processing. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Nampa%20Idaho%20downtown%20with%20historic%20district%20buildings%20and%20the%20Ford%20Idaho%20Center%20in%20the%20distance%2C%20beautiful%20Treasure%20Valley%20landscape%20with%20the%20Owyhee%20Mountains%20as%20backdrop%20at%20golden%20hour%2C%20agricultural%20fields%20and%20suburban%20developments%20spreading%20across%20the%20valley%2C%20warm%20sunset%20light%20over%20southern%20Idaho&width=1800&height=700&seq=nampa-hero-2026&orientation=landscape",
  heroImageAlt: "Nampa Idaho downtown and Treasure Valley landscape at golden hour",
  geoPosition: "43.5820;-116.5617",
  geoPlacename: "Nampa, Idaho",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Closest regional agency — approximately 800 miles, appointments required",
  },
  nearbyCitiesZips: [
    { name: "Nampa", zips: "83651, 83686, 83687" },
    { name: "Caldwell", zips: "83605, 83606, 83607" },
    { name: "Meridian", zips: "83642, 83646, 83680" },
    { name: "Boise", zips: "83701–83799" },
    { name: "Kuna", zips: "83634" },
    { name: "Middleton", zips: "83644" },
    { name: "Star", zips: "83669" },
    { name: "Eagle", zips: "83616" },
    { name: "Garden City", zips: "83714" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Treasure Valley Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Nampa and Canyon County travelers with immediate departures from Boise Airport." },
    { icon: "ri-flight-takeoff-line", title: "BOI Airport Expertise", desc: "Boise Airport is just 20 minutes away with connections to major hubs serving international routes. We know airline schedules and seasonal travel patterns." },
    { icon: "ri-graduation-cap-line", title: "CWI & NNU Student Focus", desc: "College of Western Idaho and Northwest Nazarene University students studying abroad — we guide first-time applicants through every step with expedited timelines." },
    { icon: "ri-home-heart-line", title: "Canyon County Family Specialists", desc: "From first-time passports for Canyon County kids to renewals for Treasure Valley professionals — we make the process clear, fast, and stress-free." },
  ],
  internalLinks: [
    { name: "Fast passport services in Boise, ID", route: "/cities/boise" },
    { name: "Expedited services in Meridian, ID", route: "/cities/meridian-id" },
    { name: "Idaho passport services overview", route: "/states/idaho" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Nampa via secure registered courier with direct access to State Department processing. Our registered couriers hand-deliver your documents — meaning Nampa residents get faster results without driving any distance. Ship from any UPS Store, FedEx Office, or post office in Canyon County.",
  fpcOfficeDistance: "Serving Nampa, Caldwell, Meridian, Kuna, Middleton, Star, and all Canyon County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Nampa and greater Canyon County. From the historic downtown district to the Ridgecrest and South Nampa neighborhoods, from the Ford Idaho Center area to the CWI campus corridor — we serve all of Canyon County. Our courier service eliminates the need for any in-person office visit.",
  nearbyCitiesIntro: "We serve Nampa and all Treasure Valley communities including Caldwell, Meridian, Boise, Kuna, Middleton, Star, Eagle, and Garden City. We also serve travelers departing from Boise Airport (BOI) who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Nampa as simple as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Nampa travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Treasure Valley travelers encounter unique passport issues — from last-minute study abroad acceptance letters to spring break bookings with expired documents. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Nampa and Canyon County travelers — from CWI students to Caldwell families to Meridian professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Nampa, ID? Here are the most common ones we hear from Treasure Valley travelers.",
  statePageRoute: "/states/idaho",
  statePageName: "Idaho",
  servicesIntro: "Whether you need a renewal before a BOI-to-international connection, an emergency passport for a last-minute business trip, or a first-time passport for your Canyon County family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://itd.idaho.gov/dmv/",
  dmvLabel: "Idaho Transportation Department — DMV Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "No need to travel anywhere"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Updates only by physical mail", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Closest agency is Denver (800 miles)", "Not practical for most Treasure Valley travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "International flight from BOI in two days? Business meeting in Canada this week? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Nampa travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Nampa residents renew fast — no agency visit required for most renewals. Perfect for Treasure Valley professionals and families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Nampa residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your travel plans are not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Canyon County family trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Nampa ID", description: "Urgent passport processing for Nampa Idaho travelers with immediate departure needs from Boise Airport." },
    { name: "Expedited Passport Renewal Nampa ID", description: "Fast passport renewal for Nampa Idaho residents with a previously-issued passport." },
    { name: "First-Time Passport Nampa ID", description: "New passport application services for Nampa Idaho residents applying for their first passport." },
    { name: "Child Passport Nampa ID", description: "Minor passport services for Nampa Idaho families with children under 16." },
    { name: "Name Change Passport Nampa ID", description: "Passport name correction after marriage, divorce, or legal name changes for Nampa residents." },
    { name: "Passport Card Nampa ID", description: "Passport card services for land and sea crossings from Nampa Idaho." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Nampa",
      rating: 5,
      text: "My CWI study abroad acceptance came with only 4 weeks before departure. No passport. Fast Passport Center got it done in 6 business days. The step-by-step guidance for a first-time applicant was incredible.",
      service: "New Passport",
    },
    {
      name: "The Garcias",
      location: "Nampa",
      rating: 5,
      text: "Booked a spring break trip to Cancun and realized both kids' passports were expired. Fast Passport Center handled all four applications and everything arrived in 8 days. Saved our vacation.",
      service: "Family Passport Renewal",
    },
    {
      name: "Tom D.",
      location: "Caldwell",
      rating: 5,
      text: "Needed a passport card for frequent border crossings into Canada for work. They processed it faster than I expected and the document review caught a small error I missed.",
      service: "Passport Card",
    },
    {
      name: "Amanda R.",
      location: "Nampa",
      rating: 5,
      text: "Married last year and needed a name change on my passport before our honeymoon in Italy. Fast Passport Center guided me through the process and the passport arrived in 5 business days.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "nampa-1",
      name: "Nampa Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "123 11th Ave S",
      city: "Nampa",
      state: "ID",
      zip: "83651",
      phone: "(208) 466-2741",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Nampa",
      website: "https://tools.usps.com/find-location.htm?location=1377556",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility in Nampa. Passport photos available. Appointment recommended — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "nampa-2",
      name: "Caldwell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "823 Arthur St",
      city: "Caldwell",
      state: "ID",
      zip: "83605",
      phone: "(208) 459-2129",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Caldwell — 8 miles west",
      website: "https://tools.usps.com/find-location.htm?location=1377501",
      websiteLabel: "USPS Location",
      notes: "Serves Caldwell and western Canyon County. Passport photos available. Walk-in hours limited — appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "nampa-3",
      name: "Meridian Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 N Main St",
      city: "Meridian",
      state: "ID",
      zip: "83642",
      phone: "(208) 888-3360",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Meridian — 10 miles east",
      website: "https://tools.usps.com/find-location.htm?location=1377541",
      websiteLabel: "USPS Location",
      notes: "Large acceptance facility serving Meridian and eastern Canyon County. Photo services available. Saturday appointments may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "nampa-4",
      name: "Canyon County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "111 N 11th Ave",
      city: "Caldwell",
      state: "ID",
      zip: "83605",
      phone: "(208) 454-7556",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Caldwell — 8 miles west",
      website: "https://www.canyonco.org/elected-officials/clerk/",
      websiteLabel: "Canyon County Clerk",
      notes: "County clerk passport acceptance services. Serves all Canyon County residents. No photo services on-site — bring your own photos.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver agency is 800 miles away, no walk-ins", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 800 miles to Denver or fly there", fpc: "Most Treasure Valley travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel with proof of departure", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Treasure Valley Guidance", agency: "Generic — no BOI airport or Canyon County expertise", fpc: "Full Treasure Valley/BOI Airport/CWI student knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Waiting Until Spring Break to Check Passports",
      description: "Nampa families often book spring break trips to Mexico or the Caribbean months in advance, but wait until February or March to check passports. By then, standard processing timelines may not be sufficient. Check at booking time, not packing time.",
    },
    {
      icon: "ri-error-warning-line",
      title: "CWI Study Abroad Timeline Compression",
      description: "College of Western Idaho students accepted to study abroad programs often receive acceptance letters with 4–6 weeks until departure. First-time applicants need both an acceptance facility visit and processing time — waiting until the last week creates panic.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Treasure Valley big-box stores and pharmacies produce photos that fail State Department standards. We catch this in review before it causes a rejection and adds weeks to your timeline.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Canyon County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Treasure Valley travelers booking to Asia or South America often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Nampa clients ship from any UPS Store or FedEx Office in Canyon County." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 800 miles to Denver or fly there." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Nampa?", a: "We offer Nampa-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Is there a passport office in Nampa?", a: "The Nampa Main Post Office at 123 11th Ave S serves as a passport acceptance facility for first-time applications. The Canyon County Clerk in Caldwell and the Meridian Post Office also provide acceptance services. For expedited processing, our registered courier service is the fastest option." },
    { q: "Can I apply for a passport at CWI?", a: "College of Western Idaho does not have an on-campus passport acceptance facility. Students should use the Nampa Post Office or Meridian Post Office for their acceptance clerk visit. We provide step-by-step guidance for CWI students applying for study abroad programs." },
    { q: "Where is the closest passport agency to Nampa?", a: "The Denver Passport Agency is approximately 800 miles away. For all practical expedited needs, our registered courier channel is much faster and eliminates the need for any long-distance travel." },
    { q: "Can you help with passports for flights from Boise Airport?", a: "Yes. Boise Airport (BOI) is just 20 minutes from Nampa. We regularly assist Treasure Valley travelers with expedited passports for domestic-to-international connections through BOI." },
    { q: "What documents do Nampa applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Nampa-specific checklist." },
    { q: "Where can I get passport photos in Nampa?", a: "The Nampa Post Office, Walgreens on 12th Ave S, and Staples on Marketplace Blvd all offer passport photo services. We recommend confirming photo standards compliance before visiting." },
    { q: "What is the best price for expedited service in Nampa?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "How do I check my Nampa passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Nampa to final return shipping typically matches your chosen speed tier." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Nampa Residents",
    intro: "Nampa's position in the Treasure Valley — minutes from Boise Airport and part of Idaho's fastest-growing metro area — creates distinct passport timing needs. Here's what Canyon County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BOI — Boise Airport",
        subtitle: "Primary commercial airport for the Treasure Valley, 20 minutes away",
        description: "Boise Airport connects the Treasure Valley to major U.S. hubs — Seattle, Denver, Salt Lake City, Phoenix, Minneapolis, and more — where travelers connect to international flights worldwide. Nampa residents frequently book flights through BOI for international connections. The airport has seen rapid passenger growth with Idaho's population boom, making advance planning critical during peak seasons.",
        tip: "BOI connections to Seattle, Denver, or SLC should be planned with passport validity in mind — international destinations require a valid passport at the first check-in counter, not just at the international connection point.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "CWI & NNU Study Abroad Programs",
        subtitle: "College of Western Idaho and Northwest Nazarene University",
        description: "CWI and NNU send hundreds of students abroad each year for semester exchange, summer immersions, and faculty-led programs. Many of these students — especially adult learners and first-generation college students at CWI — have never had passports. The typical acceptance-to-departure window is 6–10 weeks, requiring expedited processing to meet program timelines.",
        tip: "First-time applicants must visit an acceptance facility in person. We guide CWI and NNU students through the nearest facility with the earliest available appointment so they do not miss orientation or their flight.",
      },
      {
        icon: "ri-sun-line",
        title: "Spring Break & Winter Getaway Surge",
        subtitle: "Seasonal travel peaks for Treasure Valley families",
        description: "Late winter and early spring are the busiest seasons for Nampa's passport demand. Families book spring break trips to Mexico, winter getaways to Hawaii, and Caribbean cruises — then discover passport issues during checkout. January through March is our highest-volume period for Canyon County expedited requests. Waiting until February to check passports for a March trip is the most common mistake we see.",
        tip: "Check your entire family's passports at least 3 months before any booked international trip. Spring break and holiday getaways book fast, and passport processing demand peaks simultaneously.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Nampa & the Growing Treasure Valley",
      description: "Nampa is one of the fastest-growing cities in Idaho, part of the third-fastest-growing metro area in the U.S. New residents relocating from out of state often discover passport issues when booking their first international trip from Idaho — lost documents, expired passports, or name changes that need to be processed before travel.",
    },
  },
  destinations: {
    title: "Where Nampa Travelers Go — And Why Passports Get Urgent",
    intro: "Treasure Valley residents travel internationally for education, family, business, and recreation. Mexico is the top destination, but Europe, Canada, and cruises create regular passport demand.",
    stats: [
      { stat: "45%", label: "of Nampa expedited requests are for family vacations — spring break Mexico, Caribbean cruises" },
      { stat: "3–6 Weeks", label: "average lead time Treasure Valley travelers have from booking to international departure" },
      { stat: "Jan–Mar", label: "peak season when spring break bookings, CWI semester programs, and winter getaways converge" },
      { stat: "5 Days", label: "typical turnaround for Nampa-area expedited renewals through our courier channel" },
    ],
    destinations: [
      { name: "Mexico", context: "Cancun, Puerto Vallarta, Cabo San Lucas — spring break and winter escape favorites", urgency: "Spring break bookings peak January–February with fixed departure dates", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "British Columbia road trips, Vancouver getaways, Banff and Jasper national parks", urgency: "Cross-border trips booked 2–4 weeks out during summer", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "London, Paris, Rome — BOI connections through Seattle, Denver, or Salt Lake City", urgency: "Summer vacation bookings with fixed tour departure dates", icon: "ri-map-pin-2-line" },
      { name: "Caribbean Cruises", context: "Departures from Seattle, Galveston, or Florida — popular with Treasure Valley families", urgency: "Cruise lines have strict documentation deadlines with no flexibility", icon: "ri-map-pin-2-line" },
      { name: "Hawaii", context: "Non-international but often confused — Hawaii is domestic but many cruises continue to international waters", urgency: "Vacation bookings 2–4 months out, but passport issues only discovered at final check-in", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Treasure Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Treasure Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Boise", route: "/cities/boise" },
      { name: "Meridian", route: "/cities/meridian-id" },
    ],
  },
  photoLocations: [
    { name: "Nampa Post Office", address: "123 11th Ave S, Nampa, ID 83651", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walgreens — Nampa", address: "1115 12th Ave S, Nampa, ID 83651", hours: "Daily 7 AM – 11 PM" },
    { name: "Staples — Nampa", address: "16434 N Marketplace Blvd, Nampa, ID 83687", hours: "Mon–Fri 8 AM – 8 PM, Sat 9 AM – 6 PM" },
    { name: "The UPS Store — Nampa", address: "320 11th Ave S, Nampa, ID 83651", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Canyon County DMV — Nampa",
      address: "6107 Graye Ln, Caldwell, ID 83607",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Canyon County DMV — Caldwell",
      address: "111 N 11th Ave, Caldwell, ID 83605",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      note: "Full-service DMV. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BOI",
      name: "Boise Airport",
      distance: "About 20 minutes from Nampa",
      address: "3201 W Airport Way, Boise, ID 83705",
      note: "Primary commercial airport for the Treasure Valley. Major airlines connect through Seattle, Denver, Salt Lake City, Phoenix, and Minneapolis to international destinations worldwide.",
      flightUrl: "https://www.iflyboise.com/",
      flightLabel: "Boise Airport Website",
      featured: true,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from Idaho Vital Records. Online, mail, or in-person options available for Canyon County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Idaho Vital Records. Required for estate and legal matters in Canyon County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Canyon County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.canyonco.org/elected-officials/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Canyon County District Court. Required for name change passport corrections.",
      url: "https://www.canyonco.org/courts/",
    },
  ],
};